module.exports = __webpack_public_path__ + "static/media/esb.33be0f55.jpg";